import { useEffect, useRef } from "react";
const ACTIVITY_EVENT_KEY = "user-activity-event";
const useIdleTimeout = (onIdle, timeout = 30 * 60 * 1000) => {
    const logoutTimer = useRef(null);
    const resetTimer = () => {
        if (logoutTimer.current) clearTimeout(logoutTimer.current);
        logoutTimer.current = setTimeout(() => {
            console.log("User is idle for too long, logging out...");
            onIdle();
        }, timeout);
    };
    const broadcastActivity = () => {
        localStorage.setItem(ACTIVITY_EVENT_KEY, Date.now().toString());
        localStorage.setItem("lastActiveTime", Date.now().toString());
    };
    useEffect(() => {
        const events = ["mousemove", "keydown", "click", "scroll"];
        const activityHandler = () => {
            resetTimer();
            broadcastActivity(); // Notify other tabs
        };
        // Listen to user activity
        events.forEach((event) => window.addEventListener(event, activityHandler));
        // Listen to activity from other tabs
        const storageListener = (e) => {
            if (e.key === ACTIVITY_EVENT_KEY) {
                resetTimer(); // Reset timer if activity in another tab
            }
        };
        window.addEventListener("storage", storageListener);
        resetTimer();
        return () => {
            events.forEach((event) =>
                window.removeEventListener(event, activityHandler)
            );
            window.removeEventListener("storage", storageListener);
            clearTimeout(logoutTimer.current);
        };
    }, [onIdle, timeout]);
};
export default useIdleTimeout;